<template>
  <div id="footer">
    <svg
      class="waves"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 24 150 28"
      preserveAspectRatio="none"
      shape-rendering="auto"
    >
      <defs>
        <path
          id="gentle-wave"
          d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
        />
      </defs>
      <g class="parallax">
        <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(23,36,64,0.7" />
        <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(23,36,64,0.5)" />
        <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(23,36,64,0.3)" />
        <use xlink:href="#gentle-wave" x="48" y="7" fill="rgba(23,36,64,1)" />
      </g>
    </svg>
    <div class="footer-content">
      <div>
        <div></div>
        <p style="line-height: 20px; height: 20px">免责声明 | 隐私政策</p>
        <p>Copyright &copy; 福建矩仁律师事务所</p>
        <p>地址：福州市闽侯县高新区网讯智慧中心A栋1933室</p>
      </div>
      <div>
        <img src="@/assets/img/logo2.png" style="width: 130px; height: 120px" />
        <!-- <img
          src="@/assets/img/pic/scale.svg"
          style="width: 150px; height: 110px"
        /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  height: 200px;
  color: #d3d3d3;
  font-size: 14px;
  background-color: transparent;
  .footer-content {
    height: 100%;
    padding: 0px 20%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    background-color: $footer-background;
  }
}
.waves {
  position: relative;
  width: 100%;
  height: 15vh;
  margin-bottom: -7px; /*Fix for safari gap*/
  min-height: 100px;
  max-height: 150px;
}

.content {
  position: relative;
  height: 20vh;
  text-align: center;
  background-color: $footer-background;
}

.content a {
  margin: 0 5px;
  font-size: 12px;
  color: #333;
}

.content a:hover {
  color: white;
}

/* Animation */

.parallax > use {
  animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}
@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}
/*Shrinking for mobile*/
@media (max-width: 768px) {
  .waves {
    height: 40px;
    min-height: 40px;
  }
  .content {
    height: 30vh;
  }
  h1 {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue